import { Typography } from 'antd';
import moment from 'moment';

import { U_KEY, U_DESCRIPTION, U_TIME } from '@app/constants';
import type { NSalesFunnelsStagesApi } from '@app/services/rtkQuery/SalesFunnelsStages/types';

const { Paragraph } = Typography;

export const adaptDataToTable = (
  data: NSalesFunnelsStagesApi.ModelRobotLog[],
  handleMessageModalOpen: (value: string | null) => void
) => {
  return data.map((log) => {
    const { Id, Message, IsRead, CreatedAt } = log;

    return {
      [U_KEY]: String(Id),
      [U_DESCRIPTION]: (
        <Paragraph
          ellipsis={{ rows: 3 }}
          type={IsRead ? 'secondary' : undefined}
          className="message-name"
          onClick={() => handleMessageModalOpen(Message)}
        >
          {Message}
        </Paragraph>
      ),
      [U_TIME]: moment(CreatedAt).format('DD.MM.YYYY HH:mm'),
    };
  });
};
